import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { BsCheckCircleFill } from "react-icons/bs";
import "./VersandInfoCards.css";
import { useTranslation } from "react-i18next";

const versandCards = [
  {
    key: "cards.0",
    title: "title",
    text: "text",
  },
  {
    key: "cards.1",
    title: "title",
    text: "text",
  },
  {
    key: "cards.2",
    title: "title",
    text: "text",
  },
  {
    key: "cards.3",
    title: "title",
    text: "text",
  },
  {
    key: "cards.4",
    title: "title",
    text: "text",
  },
  {
    key: "cards.5",
    title: "title",
    text: "text",
  },
];

export default function VersandInfoCards() {
  const { t } = useTranslation();

  return (
    <section className="versand-info-section py-5 bg-light">
      <Container>
        {/* العنوان الرئيسي فوق الكروت */}
        <Row className="mb-5 text-center" data-aos="fade-up">
          <Col>
            <h3 className="fw-bold text-orange">
              {t("VersandInfoCards.title")}
            </h3>
          </Col>
        </Row>

        {/* الكروت نفسها */}
        <Row className="g-4" data-aos="fade-up">
          {versandCards.map((card, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title className="d-flex align-items-start gap-2 text-orange h6">
                    <BsCheckCircleFill className="text-orange mt-1" />{" "}
                    {t(`VersandInfoCards.${card.key}.title`)}
                  </Card.Title>
                  <Card.Text className="small text-muted">
                    {t(`VersandInfoCards.${card.key}.text`)}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}